import { AdasBox, AdasTypography } from '@components/wrapper-components'

const ALLSTATE_CALIBRATION_LEVELS = [
  {
    levels: [
      'Level 3a: Targeted Calibrations (All Other Makes)*',
      'Level 3b: Targeted Calibrations (Mercedes, Subaru)**',
      'Level 3c: Targeted Calibrations (Porsche, Audi, VW)***'
    ]
  }
]
const CSAA_CALIBRATION_LEVELS = [
  {
    title: 'Radar Sensor Calibration (RS) – OEM-Based',
    levels: ['RS1: Audi, BMW, Maserati, Nissan, Porsche, Subaru, VW', 'RS2: All other OEMs']
  },
  {
    title: 'Surround View Camera Calibration (SV) – OEM-Based',
    levels: ['SV1: Audi, BMW, Ford, Maserati, Nissan, Porsche, Toyota, VW', 'SV2: All other OEMs']
  }
]
const COMPANY_LEVEL_MAP = {
  allstate: ALLSTATE_CALIBRATION_LEVELS,
  'csaa insurance': CSAA_CALIBRATION_LEVELS,
  'state farm': ALLSTATE_CALIBRATION_LEVELS
}

export const ProductContractBanner = ({ referralData }) => {
  const company = referralData?.company?.toLowerCase()
  const calibrationLevels = COMPANY_LEVEL_MAP[company]
  if (!calibrationLevels) return null
  const renderBoldPrefix = (text) => {
    const parts = text.split(':')
    if (parts.length < 2) return text

    return (
      <>
        <strong>{parts[0]}:</strong>
        {parts.slice(1).join(':')}
      </>
    )
  }
  const shouldShowLevels = calibrationLevels.length > 0

  return (
    <AdasBox
      sx={{
        border: shouldShowLevels ? '1px solid #09519A' : 'none',
        borderRadius: shouldShowLevels ? '4px' : '6px',
        overflow: 'hidden',
        mt: 1,
        mb: 2
      }}
    >
      {/* Header */}
      <AdasBox
        sx={{
          backgroundColor: '#09519A', // Allstate blue from Figma
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '10px 16px',
          borderRadius: shouldShowLevels ? '0' : '6px',
          width: '100%'
        }}
      >
        <AdasTypography variant='body1' fontWeight='500' sx={{ letterSpacing: '0.03em', textTransform: 'capitalize' }}>
          {referralData?.company} – National Contract pricing in use
        </AdasTypography>
      </AdasBox>

      {/* Allstate-specific calibration levels */}
      {shouldShowLevels && (
        <AdasBox
          sx={{
            backgroundColor: '#fff',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: 1
          }}
        >
          {calibrationLevels.map((section) => (
            <AdasBox key={section.title}>
              {section.title && <AdasTypography variant='subtitle3'>{section.title}</AdasTypography>}
              <ul style={{ margin: '4px 0 8px 20px', padding: 0 }}>
                {section.levels.map((subLevel, subIndex) => (
                  <li key={subIndex} style={{ marginBottom: '4px' }}>
                    <AdasTypography variant='subtitle2' color='#374151'>
                      {renderBoldPrefix(subLevel)}
                    </AdasTypography>
                  </li>
                ))}
              </ul>
            </AdasBox>
          ))}
        </AdasBox>
      )}
    </AdasBox>
  )
}
